const {registerModule} = window;

class BlogCardMetadata {
  constructor(element) {
    this.element = element;
    this.initialize();
  }

  initialize() {
    this.bindUI();
    this.bindEvents();
    this.updateLayout();
    requestAnimationFrame(() => {
      this.updateLayout();
    });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => {
        this.updateLayout();
      });
    }
  }

  bindUI() {
    this.ui = {};
    this.ui.$author = this.element.querySelector('.blog-author');
    this.ui.$date = this.element.querySelector('.blog-date');
    this.ui.$primary = this.element.querySelector('.blog-metadata__primary');
    this.ui.$readTime = this.element.querySelector('.blog-readingTime');
  }

  bindEvents() {
    this.handleResize = this.debounce(() => {
      this.updateLayout();
    }, 100);

    window.addEventListener('resize', this.handleResize);
    this.resizeObserver = new ResizeObserver(this.handleResize);
    this.resizeObserver.observe(this.element);
  }

  debounce(fn, delay) {
    let timeout;
    return (...args) => {
      if (timeout) {
        clearTimeout(timeout);
      }
      timeout = setTimeout(() => {
        fn(...args);
      }, delay);
    };
  }

  updateLayout() {
    const author = this.ui.$author;
    const date = this.ui.$date;
    const primary = this.ui.$primary;
    const readTime = this.ui.$readTime;

    this.element.classList.remove(
      'blog-metadata--stacked',
      'blog-metadata--inline',
      'blog-metadata--read-wrapped',
    );

    const stacked =
      author &&
      date &&
      author.offsetTop !== date.offsetTop;

    if (stacked) {
      this.element.classList.add('blog-metadata--stacked');
      return;
    }

    if (!readTime || !primary) {
      return;
    }

    const containerWidth = this.element.clientWidth;

    if (containerWidth <= 0) {
      return;
    }

    const gap = parseFloat(getComputedStyle(this.element).columnGap) || 0;
    const fitsOneRow =
      primary.scrollWidth + gap + readTime.scrollWidth <= containerWidth;

    if (fitsOneRow) {
      this.element.classList.add('blog-metadata--inline');
    } else {
      this.element.classList.add('blog-metadata--read-wrapped');
    }
  }
}

registerModule('BlogCardMetadata', BlogCardMetadata);
